export const enableQuestion = (answerType: string, parameter1: string, operation: string, parameter2: string) => {
    if (answerType === "Boolean") {
        const bool1 = parseInt(parameter1);
        const bool2 = parseInt(parameter2);
        if (operation === "==") return bool1 === bool2;
        if (operation === "!=") return bool1 !== bool2;
    }

    if (answerType === "DateTime") {
        const date1 = Date.parse(parameter1);
        const date2 = Date.parse(parameter2);
        if (operation === "<") return date1 < date2;
        if (operation === ">") return date1 > date2;
        if (operation === "<=") return date1 <= date2;
        if (operation === ">=") return date1 >= date2;
        if (operation === "==") return date1 == date2;
        if (operation === "!=") return date1 != date2;
    }

    if (answerType === "String" || answerType === "ListValueID" || answerType === "RadioSelect" || answerType === "NativeSelect") {
        if (operation === "==") return parameter1 == parameter2;
        if (operation === "!=") return parameter1 != parameter2;
    }

    if (answerType === "Number") {
        const number1 = parseInt(parameter1);
        const number2 = parseInt(parameter2);
        if (operation === "<") return number1 < number2;
        if (operation === ">") return number1 > number2;
        if (operation === "<=") return number1 <= number2;
        if (operation === ">=") return number1 >= number2;
        if (operation === "==") return number1 == number2;
        if (operation === "!=") return number1 != number2;
    }

    return false; // Default case if no condition is met
}

export const enableSecondaryQuestion = (answerType: string, parameter1: string, operation: string, parameter2: string, parameter3: string) => {

    let enabled = false;

    if (answerType === "String" || answerType === "ListValueID" || answerType === "RadioSelect") {
        if (operation === "==") {
            if (parameter1 == parameter2 || parameter1 == parameter3) {
                enabled = true;
            }
        }
        if (operation === "!=") {
            if (parameter1 != parameter2 && parameter1 != parameter3) {
                enabled = true;
            }
        }
    }
    return enabled; // Default case if no condition is met
}


export const enableQuestionsInSet = (questions: any[], questionID: number) => {
    var controlQuestion = questions.find(x => x.questionSetQuestion.questionID === questionID);
    let secondaryQuestion = false;
    if (controlQuestion !== undefined) {
        let controlAnswer = controlQuestion.answer;
        if (controlQuestion.questionSetQuestion.text.includes("separate contract to your main trade")) {
            controlAnswer = controlQuestion.answer;
            controlQuestion = questions.find(x => x.questionSetQuestion.text.toLowerCase() === "what is your main trade?");
            secondaryQuestion = true;
        }

        if (controlQuestion.questionSetQuestion.text.toLowerCase() === "what is your main trade?") {
            let separateQuestion = questions.find(x => x.questionSetQuestion.text.includes("separate contract to your main trade"));
            if (separateQuestion !== undefined) {
                controlAnswer = separateQuestion.answer;
            }
            secondaryQuestion = true;
        }

        const newQuestions = questions.map(question => {
            if (question.enablementCriteria.length > 0) {
                for (var enablementCriteria of question.enablementCriteria) {
                    if (enablementCriteria.comparatorQuestionID === controlQuestion.questionSetQuestion.questionID) {
                        let comparatorValue = enablementCriteria.comparatorValueOrID;

                        if (comparatorValue == null) {
                            let listValueItem = enablementCriteria.enablementCriteriaListItems.find((x: { listValue: any; }) => x.listValue === controlAnswer || x.listValue === controlQuestion.answer);
                            if (listValueItem !== undefined) {
                                comparatorValue = listValueItem.listValue;
                            }
                        }
                        if (secondaryQuestion) {
                            question.questionSetQuestion.enabled = enableSecondaryQuestion(controlQuestion.questionSetAnswerType.baseTypeName, comparatorValue, enablementCriteria.operator, controlAnswer, controlQuestion.answer);
                        } else {
                            question.questionSetQuestion.enabled = enableQuestion(controlQuestion.questionSetAnswerType.baseTypeName, comparatorValue, enablementCriteria.operator, controlAnswer);
                        }

                        if (!question.questionSetQuestion.enabled) {
                            question.answer = "";
                            question.validationFail = false;
                        } else {
                            break;
                        }
                    }
                };
            }
            if (question.childInformation !== null) {
                const newChildren = question.childInformation.map((childQuestion: any) => {
                    if (childQuestion.enablementCriteria.length > 0) {
                        for (var childEnablementCriteria of childQuestion.enablementCriteria) {
                            if (childEnablementCriteria.comparatorQuestionID === controlQuestion.questionSetQuestion.questionID) {
                                let comparatorValue = childEnablementCriteria.comparatorValueOrID;

                                if (comparatorValue == null) {
                                    let listValueItem = childEnablementCriteria.enablementCriteriaListItems.find((x: { listValue: any; }) => x.listValue === controlAnswer);
                                    if (listValueItem !== undefined) {
                                        comparatorValue = listValueItem.listValue;
                                    }
                                }
                                if (secondaryQuestion) {
                                    childQuestion.questionSetQuestion.enabled = enableSecondaryQuestion(controlQuestion.questionSetAnswerType.baseTypeName, comparatorValue, childEnablementCriteria.operator, controlAnswer, controlQuestion.answer);
                                } else {
                                    childQuestion.questionSetQuestion.enabled = enableQuestion(controlQuestion.questionSetAnswerType.baseTypeName, comparatorValue, childEnablementCriteria.operator, controlAnswer);
                                }

                                if (!childQuestion.questionSetQuestion.enabled) {
                                    childQuestion.answer = "";
                                    childQuestion.validationFail = false;
                                } else {
                                    break;
                                }
                            }
                        }
                    }

                    return childQuestion;
                });
                question.childInformation = newChildren;
            }

            return question;
        });

        return newQuestions;
    } else {
        return questions;
    }

}


export const showConditionalQuestionsInSet = (questions: any[], questionID: number, value: any) => {
    value = parseInt(value);
    const newQuestions = questions.map(question => {
        if (question.questionSetQuestion.parentQuestionID === questionID) {
            question.questionSetQuestion.visible = value === 1 ? true : false;;
            question.visible = value === 1 ? true : false;
            question.answer = "";
            question.validationFail = false;
        }

        return question;
    });

    let enabledQuestions = enableQuestionsInSet(newQuestions, questionID);

    //List questions that are now disabled and depend on this question
    const disabledQuestions = enabledQuestions.filter(q =>
        q.enablementCriteria?.some((enablementCriteria: any) => enablementCriteria.comparatorQuestionID === questionID) &&
        !q.questionSetQuestion.enabled
    );

    //Disable descendant question
    disabledQuestions.forEach(q => {
        enabledQuestions = clearDependentChain(enabledQuestions, q.questionSetQuestion.questionID);
    });

    return enabledQuestions;
}

export const showConditionalChildrenQuestions = (questions: any[], parentQuestionID: number, childQuestionID: number, childIndex: number, value: any) => {

    const newQuestions = questions.map(question => {
        if (question.questionSetQuestion.questionID === parentQuestionID) {
            const newChildren = question.childInformation.map((childQuestion: any) => {
                if (childQuestion.enablementCriteria.length > 0 && childQuestion.index === childIndex) {
                    for (var enablementCriteria of childQuestion.enablementCriteria) {
                        if (enablementCriteria.comparatorQuestionID === childQuestionID) {
                            let comparatorValue = enablementCriteria.comparatorValueOrID;

                            if (comparatorValue == null) {
                                let listValueItem = enablementCriteria.enablementCriteriaListItems.find((x: { listValue: any; }) => x.listValue === value);
                                if (listValueItem !== undefined) {
                                    comparatorValue = listValueItem.listValue;
                                }
                            }

                            childQuestion.questionSetQuestion.enabled = enableQuestion(childQuestion.questionSetAnswerType.baseTypeName, comparatorValue, enablementCriteria.operator, value);

                            if (!childQuestion.questionSetQuestion.enabled) {
                                childQuestion.answer = "";
                                childQuestion.validationFail = false;
                            } else {
                                break;
                            }
                        }
                    }
                }
                return childQuestion;
            });
            question.childInformation = newChildren;
        }
        return question;
    });

    return newQuestions;
}

export const showConditionalChildrenChildren = (questions: any[], parentQuestionID: number, firstChildQuestionID: number, secondChildQuestionID: number, firstChildIndex: number, secondChildIndex: number, value: any) => {

    const newQuestions = questions.map(question => {
        if (question.questionSetQuestion.questionID === parentQuestionID) {
            const newParentChildren = question.childInformation.map((parentChildQuestion: any) => {
                if (parentChildQuestion.questionSetQuestion.questionID === firstChildQuestionID && parentChildQuestion.index === firstChildIndex) {

                    const newChildChildren = parentChildQuestion.childInformation.map((childChildQuestion: any) => {
                        if (childChildQuestion.enablementCriteria.length > 0 && childChildQuestion.index === secondChildIndex) {
                            for (var enablementCriteria of childChildQuestion.enablementCriteria) {
                                if (enablementCriteria.comparatorQuestionID === secondChildQuestionID) {
                                    let comparatorValue = enablementCriteria.comparatorValueOrID;

                                    if (comparatorValue == null) {
                                        let listValueItem = enablementCriteria.enablementCriteriaListItems.find((x: { listValue: any; }) => x.listValue === value);
                                        if (listValueItem !== undefined) {
                                            comparatorValue = listValueItem.listValue;
                                        }
                                    }

                                    childChildQuestion.questionSetQuestion.enabled = enableQuestion("String", comparatorValue, enablementCriteria.operator, value);

                                    if (!childChildQuestion.questionSetQuestion.enabled) {
                                        childChildQuestion.answer = "";
                                        childChildQuestion.validationFail = false;
                                    } else {
                                        break;
                                    }
                                }
                            }
                        }
                        return childChildQuestion;
                    });
                    parentChildQuestion.childInformation = newChildChildren;


                }
                return parentChildQuestion;
            });
            question.childInformation = newParentChildren;
        }
        return question;
    });

    return newQuestions;
}

const clearDependentChain = (questions: any[], controlQuestionId: number) => {
    return questions.map(question => {

        if (question.enablementCriteria?.some((enablementCriteria: any) => enablementCriteria.comparatorQuestionID === controlQuestionId)) {
            question.questionSetQuestion.enabled = false;
            question.answer = "";
            question.validationFail = false;

            questions = clearDependentChain(questions, question.questionSetQuestion.questionID);
        }

        return question;
    });
};